"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWeights = void 0;
exports.getCurrentTick = getCurrentTick;
exports.getPositionTicks = getPositionTicks;
exports.getTickToPrice = getTickToPrice;
exports.getPriceToTick = getPriceToTick;
exports.getTickSpacing = getTickSpacing;
exports.getPoolsWeightDistribution = getPoolsWeightDistribution;
const tslib_1 = require("tslib");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const getReceipts_js_1 = require("./sui-sdk/functions/getReceipts.js");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const coins_js_1 = require("./common/coins.js");
const maps_js_1 = require("./common/maps.js");
const decimal_js_1 = require("decimal.js");
const transactions_1 = require("@mysten/sui/transactions");
const constants_js_1 = require("./common/constants.js");
const index_js_1 = require("./index.js");
async function getCurrentTick(poolName) {
    const parentPool = await (0, getReceipts_js_1.getParentPool)(poolName, false);
    const current_sqrt_price = parentPool.content.fields.current_sqrt_price;
    const tick = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToTickIndex(new bn_js_1.default(current_sqrt_price));
    return tick;
}
async function getPositionTicks(poolName) {
    const upperBound = 443636;
    const investor = (await (0, getReceipts_js_1.getInvestor)(poolName, false));
    let lowerTick = Number(investor.content.fields.lower_tick);
    let upperTick = Number(investor.content.fields.upper_tick);
    if (lowerTick > upperBound) {
        lowerTick = -~(lowerTick - 1);
    }
    if (upperTick > upperBound) {
        upperTick = -~(upperTick - 1);
    }
    return [lowerTick, upperTick];
}
function getTickToPrice(poolName, tick) {
    const coinAName = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinBName = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    const price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToPrice(tick, coins_js_1.coinsList[coinAName].expo, coins_js_1.coinsList[coinBName].expo);
    return price.toString();
}
function getPriceToTick(poolName, price, tickSpacing, isUpper = false) {
    const coinAName = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinBName = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    let tick = cetus_sui_clmm_sdk_1.TickMath.priceToTickIndex(new decimal_js_1.Decimal(price), coins_js_1.coinsList[coinAName].expo, coins_js_1.coinsList[coinBName].expo);
    if (tick % tickSpacing) {
        if (isUpper === tick > 0) {
            tick = tick + tickSpacing - (tick % tickSpacing);
        }
        else {
            tick = tick - (tick % tickSpacing);
        }
    }
    return tick;
}
async function getTickSpacing(poolName) {
    const parentPool = await (0, getReceipts_js_1.getParentPool)(poolName, false);
    let tickSpacing = 1;
    if (maps_js_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        tickSpacing = parentPool.content.fields.tick_spacing;
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        tickSpacing = parentPool.content.fields.ticks_manager
            .fields.tick_spacing;
    }
    return tickSpacing;
}
const setWeights = async (poolIdNames, weightsString, setWeightCoinType, address) => {
    const poolIds = [];
    const txb = new transactions_1.Transaction();
    poolIdNames.forEach((poolName) => {
        if (poolName === "ALPHA-KEEPER") {
            poolIds.push("0x5a9fac4148605191b8e0de25a6671ba8008c344c1558bbaac73a947bd6c903b1");
        }
        else {
            poolIds.push(maps_js_1.poolInfo[poolName].poolId);
        }
    });
    const adminCap = await (0, index_js_1.getSuiClient)().getOwnedObjects({
        owner: address,
        filter: {
            StructType: "0x9bbd650b8442abb082c20f3bc95a9434a8d47b4bef98b0832dab57c1a8ba7123::distributor::AdminCap",
        },
        options: {
            showContent: true,
        },
    });
    if (!adminCap.data || adminCap.data.length === 0) {
        throw new Error("No adminCap data found.");
    }
    if (!adminCap.data[0].data) {
        throw new Error("adminCap.data[0].data is undefined.");
    }
    const objectId = adminCap.data[0].data.objectId;
    txb.moveCall({
        target: `${constants_js_1.conf[constants_js_1.CONF_ENV].ALPHA_LATEST_PACKAGE_ID}::distributor::set_weights`,
        typeArguments: [coins_js_1.coinsList[setWeightCoinType].type],
        arguments: [
            txb.object(objectId),
            txb.object(constants_js_1.conf[constants_js_1.CONF_ENV].ALPHA_DISTRIBUTOR),
            txb.object(constants_js_1.conf[constants_js_1.CONF_ENV].VERSION),
            txb.pure.vector("id", poolIds),
            txb.pure.vector("u64", weightsString),
            txb.object(constants_js_1.conf[constants_js_1.CONF_ENV].CLOCK_PACKAGE_ID),
        ],
    });
    // executeTransactionBlock(txb);
    // dryRunTransactionBlock(txb);
    return txb;
};
exports.setWeights = setWeights;
async function getPoolsWeightDistribution(coinTypetoSetWeight, ignoreCache) {
    const distributor = await (0, getReceipts_js_1.getDistributor)(ignoreCache);
    if (!distributor || !distributor.content.fields.pool_allocator) {
        throw new Error("Distributor or pool allocator not found");
    }
    const allocator = distributor.content.fields.pool_allocator;
    const members = allocator.fields.members.fields.contents;
    const totalWeightArr = allocator.fields.total_weights.fields.contents;
    let totalWeight = 0;
    totalWeightArr.forEach((entry) => {
        if (entry.fields.key.fields.name ===
            coins_js_1.coinsList[coinTypetoSetWeight].type.substring(2)) {
            totalWeight = Number(entry.fields.value);
        }
    });
    const poolIdmap = maps_js_1.poolIdPoolNameMap;
    const poolDataArray = [];
    for (const member of members) {
        const poolId = member.fields.key;
        const poolName = poolIdmap[poolId];
        if (poolId ===
            "0x5a9fac4148605191b8e0de25a6671ba8008c344c1558bbaac73a947bd6c903b1") {
            let weight = 0;
            if (member.fields.value.fields) {
                const poolData = member.fields.value.fields.pool_data.fields.contents;
                poolData.forEach((entry) => {
                    if (entry.fields.key.fields.name ===
                        coins_js_1.coinsList[coinTypetoSetWeight].type.substring(2)) {
                        weight = Number(entry.fields.value.fields.weight);
                    }
                });
            }
            poolDataArray.push({
                weight: weight,
                imageUrl1: undefined,
                imageUrl2: undefined,
                lockIcon: undefined,
                poolName: "ALPHA-KEEPER",
            });
            continue;
        }
        if (!maps_js_1.poolInfo[poolName]) {
            continue;
        }
        const imageUrl1 = maps_js_1.poolInfo[poolName].imageUrl1;
        const imageUrl2 = maps_js_1.poolInfo[poolName].imageUrl2;
        const lockIcon = maps_js_1.poolInfo[poolName].lockIcon;
        let weight = 0;
        if (member.fields.value.fields) {
            const poolData = member.fields.value.fields.pool_data.fields.contents;
            poolData.forEach((entry) => {
                if (entry.fields.key.fields.name ===
                    coins_js_1.coinsList[coinTypetoSetWeight].type.substring(2)) {
                    weight = Number(entry.fields.value.fields.weight);
                }
            });
        }
        poolDataArray.push({
            weight: weight,
            imageUrl1: imageUrl1,
            imageUrl2: imageUrl2,
            lockIcon: lockIcon,
            poolName: poolName,
        });
    }
    return {
        data: poolDataArray,
        totalWeight: totalWeight,
        coinType: coinTypetoSetWeight,
    };
}
//# sourceMappingURL=adminFunctions.js.map